<template>
  <el-card shadow="always" class="box-card" :width="width">
    <div slot="header" v-if="showTitle" class="card-title">
      <span>{{ title }}</span>
    </div>
    <el-row v-if="useRowCol" :gutter="gutter" class="row">
      <slot></slot>
    </el-row>
    <slot v-else></slot>
  </el-card>
</template>

<script>
export default {
  name: "CommonCard",
  props: {
    //标题
    title: {
      type: String,
      default: "卡片标题"
    },
    //是否显示标题
    showTitle: {
      type: Boolean,
      default: true
    },
    //布局
    gutter: {
      type: [Number, String],
      default: 20
    },
    //是否使用横向的栅格布局   col在插槽里编写，有较强灵活性
    useRowCol: {
      type: Boolean,
      default: true
    },
    //宽度
    width: {
      type: String,
      default: "100%"
    }
  }
};
</script>

<style lang="scss" scoped>
$margin-bottom: 10px;
.box-card {
  margin-bottom: $margin-bottom;
  .card-title {
    font-size: 0.16rem;
    font-weight: bold;
    color: #409eff;
  }
}
</style>
